import appLocalStorage from '@/appLocalStorage';

class ControlVersionAplicacion {

  constructor (instanciaAxios) {

    // instalamos un interceptor de Axios para comprobar la cabecera de respuesta
    // "x-version-aplicacion" en cada petición realizada al backend.
    // si la versión cambia, forzamos la recarga de la página
    instanciaAxios.interceptors.response.use (
      function (response) {
        if (response) { // este "if" parece gilipollesco, pero por lo visto, se generan eventos con "response = undefined" WTF!
          let ultimaVersionConocida = appLocalStorage.get ("versionAplicacion");
          let versionActual = response.headers ["x-version-aplicacion"];
          if (versionActual) {
            appLocalStorage.set ("versionAplicacion", versionActual);
            if (ultimaVersionConocida && (versionActual != ultimaVersionConocida)) {
              console.log('Cambio de versión detectado: Recargando página!');
              window.location.reload();
              // aqui no llega la ejecucion de JS
            }
          }
        }
        return response
      }
    )
  }

}

export default ControlVersionAplicacion